import React, { useEffect, useState } from "react";
// import image from '../../../../assets/images/Avatar.png'
import classNames from "classnames/bind";
import { DeleteIcon, EditIcon } from "../../../../components/Icons/Icons";
import styles from './User.module.css'
import { Link } from "react-router-dom";
import { sorterArray } from "../../../../utils";
import NameCol from "../../../../components/NameCol";
import ModalPermission from "./ModalPermisstion";

const cx = classNames.bind(styles)
const TableUser = ({ data, showAlert, showModal, showListPermission }) => {
  const [toggleSort, setToggleSort] = useState(false)
  const [dataTable, setDataTable] = useState()
  const [method, setMethod] = useState('')
  const handleToDetailInfoPage = (code) => {
    sessionStorage.setItem('code', code)
  }

  useEffect(() => {
    const newData = data ? [...data] : null
    if (newData && method.length > 0) {
      switch (toggleSort) {
        case 'up':
          const dataSortUp = sorterArray(newData, method)
          setDataTable(dataSortUp)
          break;
        case 'down':
          const dataSortDown = sorterArray(newData, method)
          setDataTable(dataSortDown.reverse())
          break;
        default:
          setDataTable(newData)
          break;
      }
    } else {
      setDataTable(newData)
    }
  }, [data, toggleSort, method])

  const handleSort = (type, method) => {
    if (type !== toggleSort) {
      setToggleSort(type)
      setMethod(method)
    } else {
      setToggleSort(false)
      setMethod('')
    }
  }


  return (
    <>
      <table className={cx("table")}>
        <thead>
          <tr>
            <th style={{
              textAlign: "center",
            }}>STT</th>
            <th>
              <NameCol active={method} title={'Người dùng'} handleSort={handleSort} method={'NAME'} />
            </th>
            <th>
              <NameCol active={method} title={'Tên quyền'} handleSort={handleSort} method={'USERTYPE_NAME'} />
            </th>
            <th>
              <NameCol active={method} title={'Đơn vị'} handleSort={handleSort} method={'COMPANY_NAME'} />
            </th>
            <th>
              <NameCol active={method} title={'Số camera quản lý'} handleSort={handleSort} method={'COUNT_CAM'} />
            </th>
            <th style={{ width: "20%" }}>
              <NameCol active={method} title={'Trạng thái'} handleSort={handleSort} method={'STATUS'} />
            </th>
            <th style={{
              textAlign: "center",
            }}>Hành động</th>
          </tr>
        </thead>
        <tbody>
          {dataTable &&
            dataTable.length > 0 &&
            dataTable.map((item, index) => {
              return (
                <tr key={index}>
                  <td onClick={e => showModal(item?.CODE)}
                    style={{
                      textAlign: "center",
                    }}
                  >
                    {index + 1}
                  </td>
                  <td onClick={e => showModal(item?.CODE)}>
                    <div
                      style={{
                        display: "flex",
                        gap: 10,
                        alignItems: "center",

                      }}
                    >
                      {item?.NAME}
                    </div>
                  </td>
                  <td onClick={e => showModal(item?.CODE)}>
                    {item?.USERTYPE_NAME}
                  </td>
                  <td onClick={e => showModal(item?.CODE)}>{item?.COMPANY_NAME}</td>
                  <td onClick={e => showListPermission(item?.CODE, item.COUNT_CAM)}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginLeft: 36,
                      }}
                    >
                      {item.COUNT_CAM}
                    </div>
                  </td>
                  <td style={{ display: "flex", flexWrap: "wrap", paddingBottom: 8.5 }} onClick={e => showModal(item?.CODE)}>
                    <span className={cx("service", item.STATUS === 'Hoạt động' && 'active')}>{item?.STATUS}</span>
                  </td>
                  <td className={cx('button-action-columns')} style={{
                    textAlign: "center",
                  }}>
                    <button onClick={(e) => showAlert(item?.CODE)}>
                      <DeleteIcon />
                    </button>
                    <Link to={'/admin/user/info-detail'} onClick={(e) => handleToDetailInfoPage(item?.CODE)}>
                      <EditIcon />
                    </Link>
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>

    </>
  );
};

export default TableUser;
